import React from 'react'
import { connect } from 'react-redux'
import Validator from 'validatorjs'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import RetractablePanel from 'components/RetractablePanel'
import Input from 'components/Input'
import Button from 'components/Button'

import SelectWorkshop from './SelectWorkshop'

import { changeEditting, newWorkshop } from './actions'
import { statusChanged } from 'components/RequestStatus/actions'

import { CLAIM_DATA_URL, UPDATE_WORKSHOP } from 'constants'

import './styles.scss'

export class Workshop extends BaseComponent {
  static validationRules = {
    name: 'string|required|min:2',
    address: 'string|required|min:2',
    phone: 'string|required|min:2'
  }

  constructor() {
    super()
    this.state = {
      buttonProps: {
        disabled: false
      },
      workshop: {},
      errors: {}
    }

    this._bind( '_onEdit', '_renderEditForm', '_renderData', '_fetchWorkshop',
                '_handleChange', '_handleSubmit', '_validate', '_onCancelEdit')
  }

  componentDidMount() {
    this._fetchWorkshop()
  }

  _fetchWorkshop() {
    request(CLAIM_DATA_URL(this.props.vehicleId))
      .then(({claim}) => {
        this.setState({
          workshop: {
            ...claim.workshop
          }
        })
        this.props.newWorkshop(false)
      })
      .catch((err) => {console.log(err)})
  }

  _onEdit(evt) {
    evt.preventDefault()
    this.panel.open()
    this.props.changeEditting(true)
  }

  _onCancelEdit(evt) {
    evt.preventDefault()
    this.panel.open()
    this.props.changeEditting(false)
  }

  _handleChange(e) {

    this.setState({
      workshop: {
        ...this.state.workshop,
        [e.target.name]: e.target.value
      }
    })
    this._validate(e)
  }


  _validate(e) {
    let workshop = {
      ...this.state.workshop,
      [e.target.name]: e.target.value
    }
    const validator = new Validator(workshop, Workshop.validationRules)
    this.setState({
      buttonProps: {
        disabled: !validator.passes()
      },
      errors: {
        ...validator.errors.errors
      }
    })
  }

  _handleSubmit(e) {
    e.preventDefault()
    this.props.updateRequestStatus('progress', 'Cambio de datos en progreso...')
    request(UPDATE_WORKSHOP(this.state.workshop.id), {
      method: 'PUT',
      body: {...this.state.workshop}
    }).then((res) => {
      this.props.updateRequestStatus(res.status, res.message)
    }).catch((err) => {
      this.props.updateRequestStatus('error', 'No pudimos modificar los datos')
    })

    this.props.changeEditting(!this.props.editting)
  }

  _renderHeaderActions() {
    return !this.props.editting ? (
      <div>
        <button onClick={this._onEdit}>
          <i className="material-icons">edit</i>
        </button>
      </div>
    ) : (
      <div>
        <button onClick={this._onCancelEdit}>
          <i className="material-icons">close</i>
        </button>
      </div>
    )
  }


  _renderEditForm() {
    return(
      <div>
        <SelectWorkshop claimId={this.props.claimId} />
        <p className="orMessage">ó</p>
        <form onSubmit={this._handleSubmit} className="SinisterWorkshop__form">
          <p>Edita el actual</p>
          <div className="form-field">
            <label>Nombre:</label>
            <Input  name="name"
                    errors={this.state.errors.name}
                    onChange={this._handleChange}
                    defaultValue={this.state.workshop.name} />
          </div>
          <div className="form-field">
            <label>Dirección:</label>
            <Input  name="address"
                    errors={this.state.errors.address}
                    onChange={this._handleChange}
                    defaultValue={this.state.workshop.address} />
          </div>
          <div className="form-field">
            <label>Teléfono:</label>
            <Input  name="phone"
                    errors={this.state.errors.phone}
                    onChange={this._handleChange}
                    defaultValue={this.state.workshop.phone} />
          </div>
          <div className="controls d-flex justify-content-end">
            <Button buttonType="primary"
                    size="small"
                    {...this.state.buttonProps}>Actualizar Taller</Button>
          </div>
        </form>
      </div>
    )
  }

  _renderData() {
    return(
      <div className="SinisterWorkshop__data">
        <div className="data-field">
          <label>Nombre:</label>
          <p><span>{this.state.workshop.name}</span></p>
        </div>
        <div className="data-field">
          <label>Dirección:</label>
          <p><span>{this.state.workshop.address}</span></p>
        </div>
        <div className="data-field">
          <label>Teléfono:</label>
          <p><span>{this.state.workshop.phone}</span></p>
        </div>
      </div>
    )
  }

  render() {
    !!this.props.newWorkshopStatus && this._fetchWorkshop()
    return (
      <div id="SinisterWorkshop" className="SinisterWorkshop">
        <RetractablePanel
          ref={(panel) => this.panel = panel}
          name="Taller"
          actionButtons={this._renderHeaderActions()}
          isToggle={true}
        >
          {!!this.state.workshop.name ? (
            this.props.editting ? this._renderEditForm() : this._renderData()
          ) : (
            <SelectWorkshop claimId={this.props.claimId} />
          ) }
        </RetractablePanel>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    editting: state.selectWorkshop.get('editting'),
    workshop: state.selectWorkshop.get('workshop'),
    newWorkshopStatus: state.selectWorkshop.get('newWorkshopStatus')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeEditting: (editting) => dispatch(changeEditting(editting)),
    newWorkshop: (state) => dispatch(newWorkshop(state)),
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Workshop)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/ClaimData/Workshop/index.js